module.exports = __webpack_public_path__ + "img/cnn.974f505e.png";